<div class="mtn-container">
    <div class="mtn-title">
        <p>{{ moduleName }}</p>
    </div>
    <div class="outer-wrapper p-datatable mtn-header">
        <!--<div class="p-datatable-header"><span class="header-title">PLAN</span></div> -->
        <div *ngIf="showForm.quickLinks" class="form-content">
            <form [formGroup]="forms.lineSubLineLovForm" class="form">
                <div class="form-container-grid top-form">
                    <div class="field required">
                        <label>Line</label>
                    </div>
                    <div class="">
                        <input formControlName="lineCdWithDescDisplay">
                        <button matSuffix class="btn btn-search" type="button" (click)="openLov('LINE')" [disabled]='btns.lov.lineDisabled'><mat-icon>search</mat-icon></button>
                    </div>
                    <div class="field required">
                        <label>Subline</label>
                    </div>
                    <div class="">
                        <input formControlName="subLineCdWithDescDisplay">
                        <button matSuffix class="btn btn-search" type="button" (click)="openLov('SUBLINE')" [disabled]='btns.lov.sublineDisabled'><mat-icon>search</mat-icon></button>
                    </div>
                    <div class="field required">
                        <label>Plan</label>
                    </div>
                    <div class="">
                        <input formControlName="planCdWithDescDisplay">
                        <button matSuffix class="btn btn-search" type="button" (click)="openLov('PLAN')" [disabled]='btns.lov.planDisabled'><mat-icon>search</mat-icon></button>
                    </div>
                </div>
            </form>
        </div>
        <osp-table [tblConfig]="tblConfig.quickLinks" (onRowClick)="onRowClick.quickLinks($event)"></osp-table>
        <div id="quickLinks-maintenance-loading"><div class="form-loader"></div></div>
        <div *ngIf="showForm.quickLinks" class="form-content">
            <form [formGroup]="forms.quickLinksForm" class="form">
                <div id="quickLinks-error-message"></div>
                <div class="form-container-grid">
                    <div class="field">
                        <label>Link No</label>
                    </div>
                    <div>
                        <input formControlName="linkNo" >
                    </div>
                    <div class="field required">
                        <label>Active</label>
                    </div>
                    <div>
                        <select formControlName="activeTag">
                            <option value="A">Yes</option>
                            <option value="I">No</option>
                        </select>
                    </div>
                    <div class="field required">
                        <label>Link Name</label>
                    </div>
                    <div class="span">
                        <input formControlName="linkName" maxlength="500">
                    </div>
                    <div class="field">
                        <label>Link Path</label>
                    </div>
                    <div class="span">
                        <input formControlName="linkPath" maxlength="2000">
                    </div>
                    <div class="field">
                        <label>Remarks</label>
                    </div>
                    <div class="span">
                        <input formControlName="remarks" maxlength="4000">
                    </div>
                    <div class="field">
                        <label>Last Update User</label>
                    </div>
                    <div>
                        <input formControlName="lastUpdateUser" >
                    </div>
                    <div class="field">
                        <label>Last Update</label>
                    </div>
                    <div>
                        <input formControlName="lastUpdate" >
                    </div>
                </div>
            </form>
            <div class="btn-grp">
                <button *ngIf="btns.quickLinks.updateDisabled" class="btn btn2" type="button" (click)="onAdd.quickLinks()" [disabled]="btns.quickLinks.addDisabled" >ADD</button>
                <button *ngIf="!btns.quickLinks.updateDisabled" class="btn btn2" type="button" (click)="onUpdate.quickLinks()" >UPDATE</button>
                <button class="btn btn2" type="button" (click)="onDelete.quickLinks()" [disabled]='btns.quickLinks.deleteDisabled'>DELETE</button>
            </div>
            <div class="mtn-title"></div>
            <div class="btn-grp">
                <button class="btn btn2" type="button" (click)="onSave.quickLinks()" [disabled]='btns.quickLinks.saveDisabled'>SAVE</button>
            </div>
        </div>
    </div>
</div>
